<script setup>
import { useTrainerAccountStore } from '@/stores/trainerAccount'

definePage({
  meta: {
    layout: 'blank',
    allowRestricted: true,
  },
})

const accountStore = useTrainerAccountStore()
const router = useRouter()
const { t } = useI18n()

onMounted(async () => {
  if (!accountStore.trainer)
    await accountStore.bootstrap()
})

const logout = async () => {
  await accountStore.logout()
  await router.replace({ name: 'login' })
}

const stateTitle = computed(() => {
  if (accountStore.isSuspended)
    return t('accountRestricted.suspended')
  if (accountStore.isDeactivated)
    return t('accountRestricted.deactivated')
  
  return t('accountRestricted.restricted')
})
</script>

<template>
  <div class="auth-wrapper d-flex align-center justify-center pa-4">
    <VCard
      flat
      border
      max-width="560"
      width="100%"
      class="pa-2"
    >
      <VCardText>
        <h1 class="text-h4 mb-1">
          {{ stateTitle }}
        </h1>

        <VChip
          class="my-4"
          :color="accountStore.isSuspended ? 'warning' : 'secondary'"
          variant="tonal"
          label
        >
          {{ $t('accountRestricted.stateLabel') }} {{ accountStore.lifecycleState }}
        </VChip>

        <VAlert
          type="warning"
          variant="tonal"
          role="status"
          class="mb-4"
        >
          {{ accountStore.lifecycleLabel }}
        </VAlert>

        <p class="text-medium-emphasis mb-6">
          {{ $t('accountRestricted.description') }}
        </p>

        <VBtn
          color="primary"
          :loading="accountStore.loading"
          @click="logout"
        >
          {{ $t('common.signOut') }}
        </VBtn>
      </VCardText>
    </VCard>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
